import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* Mobile-first styles */
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }

  /* Improve touch targets on mobile */
  button, a, [role="button"] {
    min-height: 44px;
    min-width: 44px;
  }

  /* Prevent text size adjustment after orientation changes */
  html {
    -webkit-text-size-adjust: 100%;
  }

  /* Improve scrolling on iOS devices */
  * {
    -webkit-overflow-scrolling: touch;
  }
`;

export default GlobalStyle; 